import React from 'react';
import LandingSection from './LandingSection';
import LandingCard from './LandingCard';
import AnimatedCounter from './AnimatedCounter';
import { STATS } from './landingData';

export default function LandingStats() {
  return (
    <LandingSection
      id="stats"
      className="mt-10"
      innerClassName="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:gap-4"
    >
      {STATS.map((s) => {
        const Icon = s.icon;
        return (
          <LandingCard key={s.label} className="px-4 py-4" hover>
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-600/15 ring-1 ring-blue-500/20">
                <Icon className="h-5 w-5 text-blue-300" />
              </div>
              <div className="min-w-0">
                <p className="text-xs text-white/55">{s.label}</p>
                <p className="mt-0.5 text-lg font-semibold text-white">
                  <AnimatedCounter value={s.value} />
                  <span className="text-white/50">+</span>
                </p>
              </div>
            </div>
          </LandingCard>
        );
      })}
    </LandingSection>
  );
}

